module.exports = __webpack_public_path__ + "img/geofisica_9-16_810.d9095f5d.webp";